import React from 'react';
import { SvgComponent } from './SvgComponent';
import { IconProps } from './types';

const SpinnerIcon = ({ width = 24, height = 24, color = '#38383E', ...props }: IconProps) => (
  <SvgComponent width={width} height={height} viewBox='0 0 40 40' {...props}>
    <circle
      cx='20'
      cy='20'
      r='18'
      stroke='url(#gradient)'
      strokeWidth='4'
      fill='none'
      strokeLinecap='round'
    />
    <defs>
      <linearGradient id='gradient' x1='0' y1='0' x2='100%' y2='0'>
        <stop offset='0%' stopColor={color} />
        <stop offset='85%' stopColor='white' />
      </linearGradient>
    </defs>
  </SvgComponent>
);

export default SpinnerIcon;
